<!--
    描述：指标分析首页
    时间：2020-05-15
    Created by ws
-->
<template>
	<w-split v-model="splitV"
			 class="target-main">
		<!-- 左侧结构树 -->
		<left-structure slot="left"
						:editable="false"
						@rowClick="leftRowClick"></left-structure>

		<!-- 右侧表格 -->
		<div class="w-strucutre-layout"
			 slot="right">
			<div class="w-strucutre-header">
				<div class="btnGroups">
					<el-button size="small"
							   icon="el-icon-menu"
							   type="primary"
							   @click="doFilter">列过滤</el-button>
					<el-button type="primary"
							   plain
							   size="mini"
							   icon="el-icon-download"
							   v-if="roleBtns.includes('target-Excel') || curSource === '1'"
							   @click="doExport('excel')">导出Excel</el-button>
					<el-button icon="el-icon-upload"
							   size="mini"
							   v-if="roleBtns.includes('target-Html') || curSource === '1'"
							   @click="doExport('html')">导出Html</el-button>
					<el-button size="small"
							   icon="el-icon-plus"
							   type="primary"
                                 v-if="roleBtns.includes('target-compare')"
							   @click="doCompare">添加对比</el-button>
				</div>
			</div>
			<div class="w-structure-content"
				 v-loading="sheetLoading">
				<target-table :resData="resData"
							  ref="targetSheet"></target-table>
			</div>

			<!-- 弹窗信息 -->
			<el-dialog :title="dialogObj.title"
					   :visible.sync="dialogObj.visible"
					   :width="dialogObj.width"
					   :close-on-click-modal="false"
					   @closed="handleClose">
				<!-- 显示数据范围 -->
				<div class="text-center h100 overflow-hidden">
					<!-- 添加对比 -->
					<add-compare ref="addContrast"
								 v-if="dialogObj.type === 'add'"
								 :curLevel="curLevel"
								 :curRowId="curRowId"
								 @onSuccess="handleCompare"></add-compare>

					<!-- 列过滤 -->
					<target-filter ref="filterShow"
								   v-if="dialogObj.type === 'filter'"
								   :tableData="curSearchData"
								   @onSuccess="handleFilter"></target-filter>
				</div>

				<div slot="footer"
					 class="dialog-footer text-center">
					<el-button @click="doCancel"
							   size="small">取 消
					</el-button>
					<el-button type="primary"
							   size="small"
							   :loading="btnLoading"
							   @click="doConfirm">确 定
					</el-button>
				</div>
			</el-dialog>
		</div>
	</w-split>
</template>

<script>
import leftStructure from '@/views/project-management/project-info/components/left_structure'
import targetTable from './target_table'
import addCompare from './target_compare'
import { mapState } from 'vuex'
import targetFilter from './target_filter'
import { getTargetAnalysis } from '@/api/modules/dataProject'
import { exportExcel, dateFormat } from '@/utils/tools'

export default {
	name: 'Analysis-target',
	components: {
		leftStructure,
		targetTable,
		addCompare,
		targetFilter
	},
	data() {
		return {
			splitV: 0.3,
			sheetLoading: false,
			resData: {}, // 新动态返回的数据
			exportType: '',
			// 弹窗对象
			dialogObj: {
				title: '添加对比',
				visible: false,
				width: '90%',
				type: 'add',
				exportExcel: false
			},
			btnLoading: false,
			curLevel: null,
			curRowId: this.curProjectId, // 当前点击的左侧行ID
			curSearchData: [] // 当前查询的数据
		}
	},
	created() {
		// console.log(111)
	},
	methods: {
		// 左侧树点击事件
		leftRowClick(row) {
			let params = {
				id: row.id,
				levelType: row.levelType,
				busProContractList: [
					{
						id: row.id,
						projectName: row.projectName,
						sixCalculationMap: {
							estimateMoney: 1,
							controlMoney: 1,
							biddingMoney: 1,
							reportMoney: 1,
							beforeMoney: 1,
							afterMoney: 1
						}
					}
				]
			}
			// 参数保存
			this.curLevel = row.levelType
			this.curRowId = row.id
			this.curSearchData = params.busProContractList

			switch (row.levelType) {
				case 2:
					this.$message.warning('当前层级 暂无数据!')
					break
				default:
					this.getRightData(params)
					break
			}
		},

		// 获取当前结构的指标数据
		getRightData(params) {
			this.sheetLoading = true
			this.resData = {}
			getTargetAnalysis(params)
				.then(res => {
					this.sheetLoading = false
					if (res.operationCode === 1) {
						this.resData = res.data.contentColumn ? res.data : {}
					}
				})
				.catch(err => {
					this.sheetLoading = false
				})
		},

		// 点击列过滤
		doFilter() {
			this.dialogObj.visible = true
			this.dialogObj.type = 'filter'
			this.dialogObj.width = '800px'
			this.dialogObj.title = '列过滤'
		},
		// 确认列过滤
		handleFilter(data) {
			if (this.dialogObj.exportExcel) {
				let saveName =
					'指标分析列表数据' + dateFormat('yyyy-MM-dd hh:ss:mm')
				exportExcel(
					'busProContract/exportStructurePrice',
					{
						id: this.curRowId,
						busProContractList: this.curSearchData,
						levelType: this.curLevel,
						saveName: saveName,
						type: this.exportType,
						projectId: this.curProjectId
					},
					saveName
				)
				this.dialogObj.exportExcel = false
				this.handleClose()
			} else {
				let params = {
					id: this.curRowId,
					levelType: this.curLevel,
					busProContractList: data
				}
				this.getRightData(params)
				this.handleClose()
			}
		},

		// 点击导出
		doExport(exportType) {
			this.dialogObj.exportExcel = true
			this.dialogObj.visible = true
			this.dialogObj.type = 'filter'
			this.dialogObj.width = '800px'
			this.dialogObj.title = '自定义导出'
			this.exportType = exportType
		},

		// 点击添加对比
		doCompare() {
			this.dialogObj.type = 'add'
			this.dialogObj.visible = true
		},

		// 确认对比
		handleCompare(data) {
			if (data.length > 0) {
				data.map(x => {
					if (!x.projectName) {
						x.projectName = x.danXiangName
					}
				})
				this.curSearchData = data
				let params = {
					id: this.curRowId,
					levelType: this.curLevel,
					busProContractList: data
				}
				this.getRightData(params)
			}
			this.handleClose()
		},

		// 弹窗确认事件
		doConfirm() {
			this.btnLoading = true

			if (this.dialogObj.type === 'add') {
				this.$refs.addContrast.doSave()
			} else {
				this.$refs.filterShow.doSave()
			}
			// 重置按钮状态
			this.resetBtn()
		},

		//关闭弹框
		doCancel() {
			this.dialogObj.visible = false
			if (this.dialogObj.type === 'filter')
				this.dialogObj.exportExcel = false
		},

		// 按钮释放状态
		resetBtn() {
			setTimeout(() => {
				this.btnLoading = false
			}, 2000)
		},

		// 关闭弹窗事件
		handleClose() {
			this.dialogObj.visible = false
			this.dialogObj.title = '添加对比'
			this.dialogObj.type = ''
			this.dialogObj.width = '1200px'
			this.btnLoading = false
		}
	},
	computed: {
		// 当前的 项目来源：'0' 是造价系统的， '1' 是审计系统推送的
		curSource() {
			return this.$route.query.source || '0'
		},
		curProjectId() {
			return this.$route.query.projectId || null
		},
		...mapState('menu', {
			roleBtns: state => state.roleBtns
		}),
	},
	watch: {
		curProjectId() {
			this.splitV = 0.3
		}
	}
}
</script>

<style scoped lang="less">
.target-main {
	font-size: 14px;
	position: relative;

	.add-contrast-header {
		height: 38px;
		text-align: left;
	}
}
</style>
